import { Season } from "@prisma/client";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { SeasonForm, UpdateSeason } from "../models/Season";
import { useBackendMutationFunction } from "./common/useBackendMutationFunction";
import { useBackendQueryFunction } from "./common/useBackendQueryFunction";
import { UrlQuery } from "./common/useBackendUrl";

export function useGetCurrentSelectedSeason() {
  return useQuery([]);
}

export const GetSeasonsKey = "GetSeasons";
export const GetCurrentSeasonKey = "GetCurrentSeason";

export interface DuplicateSeason extends SeasonForm {
  bundesligaTeams: string[];
  pokalTeams: string[];
}

export function useGetSeasons() {
  const queryFn = useBackendQueryFunction<Season[]>("/seasons");
  return useQuery<Season[]>([GetSeasonsKey], queryFn);
}

interface UseGetSeasonProps extends UrlQuery {
  id: string;
}

export function useGetSeason(props: UseGetSeasonProps) {
  const queryFn = useBackendQueryFunction<Season>("/seasons/:id", props);

  return useQuery<Season>([GetSeasonsKey, props], queryFn);
}
interface UseGetSeasonByStartYearProps extends UrlQuery {
  startYear: number;
}
export function useGetSeasonByStartYear(props: UseGetSeasonByStartYearProps) {
  const queryFn = useBackendQueryFunction<Season>(
    "/seasons/getByStartYear/:startYear",
    props
  );

  return useQuery<Season>([GetSeasonsKey, props], queryFn);
}

export function useGetCurrentSeason() {
  const queryFn = useBackendQueryFunction<Season>("/seasons/current");
  return useQuery<Season>([GetCurrentSeasonKey], queryFn);
}

interface UseDeleteSeason extends UrlQuery {
  seasonId: string;
}
export function useDeleteSeason(props: UseDeleteSeason) {
  const mutationFn = useBackendMutationFunction<Season, void>(
    "/seasons/:seasonId",
    "DELETE",
    props
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetSeasonsKey);
    },
  });
}

export function usePostSeason() {
  const mutationFn = useBackendMutationFunction<Season, SeasonForm>(
    "/seasons",
    "POST"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetSeasonsKey);
    },
  });
}
export function useDuplicateSeason() {
  const mutationFn = useBackendMutationFunction<Season, DuplicateSeason>(
    "/seasons/duplicate",
    "POST"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetSeasonsKey);
    },
  });
}

export function usePatchSeason() {
  const mutationFn = useBackendMutationFunction<Season, UpdateSeason>(
    "/seasons",
    "PATCH"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetSeasonsKey);
    },
  });
}

export function usePatchCurrentSeason() {
  const mutationFn = useBackendMutationFunction<Season, string>(
    "/seasons/current",
    "PATCH"
  );
  const queryClient = useQueryClient();
  return useMutation(mutationFn, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(GetCurrentSeasonKey);
    },
  });
}
